import styled from "styled-components";

export const FiSalesContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const FiSalesTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;  
`;
export const FiSalesTopColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FiSalesBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
`;

export const FiSalesSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0px;
  border-bottom: 1px solid #F2F2F2;
`;

export const FiSalesSectionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const FiSalesSectionRowLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const SourceInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;